"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.pressPropTypes = exports.default = void 0;
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _rectProp = _interopRequireDefault(require("./rectProp"));
var _getPropSelector = _interopRequireDefault(require("./getPropSelector"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const pressHandlerPropTypes = {
  onPress: _propTypes.default.func,
  onPressIn: _propTypes.default.func,
  onPressOut: _propTypes.default.func,
  ..._Platform.default.select({
    web: {
      onMouseEnter: _propTypes.default.func,
      onMouseLeave: _propTypes.default.func,
      onFocus: _propTypes.default.func,
      onBlur: _propTypes.default.func
    },
    default: {
      onLongPress: _propTypes.default.func
    }
  })
};
const pressPropTypes = exports.pressPropTypes = {
  ...pressHandlerPropTypes,
  disabled: _propTypes.default.bool,
  ..._Platform.default.select({
    web: {},
    default: {
      hitSlop: _propTypes.default.number,
      pressRetentionOffset: _propTypes.default.oneOfType([_propTypes.default.number, _rectProp.default.propType])
    }
  })
};
var _default = exports.default = {
  /**
   * Proptypes for clickable or pressable components, including web-only props
   */
  types: pressPropTypes,
  /**
   * Filters a props object, returning only the platform-relevant press props defined above
   */
  select: (0, _getPropSelector.default)(pressPropTypes),
  selectHandlers: (0, _getPropSelector.default)(pressHandlerPropTypes)
};